
export default function CTA() {
  return (
    <section id="contact" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/e242b9cdacd668d4cb77e6a8dab5abb5.jpg" 
          alt="Beautiful Landscaping"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-32 w-full">
        <div className="flex flex-col justify-between min-h-[500px] sm:min-h-[600px]">
          <div className="max-w-3xl">
            <h2 className="text-3xl sm:text-7xl font-bold text-white leading-tight mb-4 sm:mb-6" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
              start generating<br />quality leads today
            </h2>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 sm:gap-12">
            <div className="max-w-xl">
              <p className="text-base sm:text-2xl text-white font-light leading-relaxed" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.3)', fontWeight: 300 }}>
                Join 500+ landscaping companies<br />reducing their customer acquisition costs
              </p>
            </div>

            <a href="#" className="group bg-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center overflow-hidden hover:scale-105 cursor-pointer whitespace-nowrap">
              <span className="text-gray-900 font-semibold px-6 sm:px-10 py-3 sm:py-5 text-base sm:text-lg">
                Get Started Free
              </span>
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-900 rounded-full flex items-center justify-center mr-1">
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xl sm:text-2xl text-white group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
